import { Reveal } from './Reveal.tsx';
import { getIcon } from '../../lib/icons.ts';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function BeforeAfter({ config }: { config: SiteConfig }) {
  const { beforeAfter } = config;

  return (
    <section style={{ padding: '56px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <Reveal>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, marginBottom: 32 }}>{beforeAfter.title}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          <div className="card" style={{ borderColor: 'var(--danger)', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--danger)' }}>{beforeAfter.before.title}</div>
            {beforeAfter.before.items.map((item) => {
              const Icon = getIcon(item.icon);
              return (
                <div key={item.text} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <Icon size={16} color="var(--danger)" />
                  <span style={{ fontSize: 14, color: 'var(--text-secondary)' }}>{item.text}</span>
                </div>
              );
            })}
          </div>
          <div className="card" style={{ borderColor: 'var(--success)', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--success)' }}>{beforeAfter.after.title}</div>
            {beforeAfter.after.items.map((item) => {
              const Icon = getIcon(item.icon);
              return (
                <div key={item.text} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <Icon size={16} color="var(--success)" />
                  <span style={{ fontSize: 14, fontWeight: 600 }}>{item.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
